"use client";

import React, { useState } from "react";
import { useI18n } from "@/i18n/I18nProvider";
import { GuestChatPanel } from "@/components/GuestChatPanel";

/**
 * Floating realtime chat on a booking site. A visitor starts a conversation with their name and a question; a guest with
 * a booking chats under that booking. The conversation itself lives in GuestChatPanel.
 */
export function SiteChatWidget({
  hostname,
  siteName,
  booking,
  offsetBottom = 16,
}: {
  hostname: string;
  siteName: string;
  booking?: { reference: string; accessToken: string } | null;
  offsetBottom?: number;
}) {
  const { t } = useI18n();
  const [open, setOpen] = useState(false);
  const [unread, setUnread] = useState(0);

  return (
    <>
      <button className="ps-chat-fab" style={{ bottom: `max(${offsetBottom}px, env(safe-area-inset-bottom))` }} onClick={() => setOpen((o) => !o)} aria-expanded={open} aria-label={t("chat.guest.open")}>
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
        {unread > 0 && !open && <span className="ps-chat-badge">{unread}</span>}
      </button>

      <div className="ps-chat-panel" role="dialog" aria-label={t("chat.guest.title", { name: siteName })} hidden={!open}>
        <div className="ps-chat-head">
          <div>
            <strong>{t("chat.guest.title", { name: siteName })}</strong>
          </div>
          <button onClick={() => setOpen(false)} aria-label={t("chat.guest.close")}>{"×"}</button>
        </div>
        <GuestChatPanel start={{ kind: "site", hostname }} storageKey={`villa_chat:${hostname}`} booking={booking} active={open} onUnread={setUnread} />
      </div>
    </>
  );
}
